import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';
import { Proforma } from '../../models';

export const type = 'orders';

export interface OrdersState extends EntityState<Proforma, number> {
    isFetching: boolean;
    errorMessage?: string;
}

export const adapter = createEntityAdapter<Proforma>();

export const initialState: OrdersState = adapter.getInitialState({
    isFetching: false,
    errorMessage: undefined,
});
